import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { InspectionStatus } from '../../utilities/enums';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { InspectionList, InspectionListCollection } from './queryBuilder';

const useSelectedSiteDisciplineInspections = (site: number, discipline: number) => {
  const getInspectionQuery = useCallback(
    (collection: InspectionListCollection) =>
      collection?.find({
        selector: {
          $and: [{ site }, { discipline }],
        },
      }),
    [site, discipline],
  );

  const { result: allInspections, isFetching } = useRxData<InspectionList>(
    RxdbCollectionName.INSPECTION_LIST,
    getInspectionQuery,
    {
      json: true,
    },
  );

  const liSignPendingInspections = allInspections.filter(
    inspection => inspection.assetInspectionStatusId === InspectionStatus.LI_SIGN_PENDING,
  );

  return { allInspections, liSignPendingInspections, isFetching };
};

export default useSelectedSiteDisciplineInspections;
